import { render } from "./PostList.vue?vue&type=template&id=4308b784&scoped=true"
import script from "./PostList.vue?vue&type=script&lang=js"
export * from "./PostList.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4308b784"

export default script